import { useState } from "react";
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { IoMdHeart } from "react-icons/io";
import { IoHeartOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import DefaultImage from "../../assets/png/defaultImage.png";
import { saveFavorite } from "../../redux/slices/favorite/favoriteSlice";
import { dispatch } from "../../redux/store";
import { AppRoutes } from "../../routes/path";
import { Modal } from "../shared/Modal";
import ProductDetailsModal from "./ProductDetailsModal";

const Product = ({
  name,
  price,
  oldPrice,
  rating,
  image,
  id,
  description,
  inStock,
}: {
  name: string;
  price?: number;
  oldPrice?: number;
  rating: number;
  image?: any;
  dark?: boolean;
  containerDesign?: number;
  id: number;
  description?: string;
  variables?: any[];
  home?: boolean;
  favourite?: boolean;
  inStock: boolean;
}) => {
  const navigate = useNavigate();
  const { favorites } = useSelector((state: any) => state.favorite);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [favourite, setFavourite] = useState(
    favorites.some(
      (f: any) => f.productResponses && f.productResponses[0]?.id === id
    )
  );

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(
      saveFavorite({
        productId: id,
      })
    ).then((res) => {
      if (res?.success) setFavourite(!favourite);
    });
  };

  const handleNavigate = (productId: number) => {
    navigate(AppRoutes.productDetail + `/${productId}`);
  };

  function capitalizeFirstLetter(str: string) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <>
      <div
        className="bg-white rounded-[7px] border-[1px] lg:aspect-[250/340] transition-all active:shadow-[#05A30D] hover:shadow-custom h-full flex flex-col py-[3px] px-[5px] overflow-hidden"
        onClick={() => handleNavigate(id)}
      >
        <div
          className={`rounded-[8px] aspect-square w-full h-[80%] flex flex-row overflow-hidden items-center self-center justify-center relative`}
        >
          <div
            onClick={handleFavoriteClick}
            className={`flex absolute top-1 right-1 z-[2] ${
              favourite
                ? "rounded-full bg-white cursor-pointer mr-2 p-1 self-center transition-all active:bg-[#05A30D] active:text-white hover:scale-125 hover:opacity-80 flex items-center justify-center h-[32px] w-[32px] ml-[2px]"
                : "rounded-full bg-white flex absolute top-1 right-1 items-center transition-all hover:scale-125 hover:opacity-80 justify-center h-8 w-8"
            }`}
          >
            {favourite ? (
              <IoMdHeart size={18} fill="#05A30D" />
            ) : (
              <IoHeartOutline size={18} />
            )}
          </div>
          <img
            alt="product_image_t&k"
            src={image?.length > 0 ? image[0] : DefaultImage}
            className={`object-contain h-full object-center aspect- rounded-[7px] w-full hover:scale-110 transition-all`}
          />
        </div>
        <div className="flex justify-between items-center px-1 py-1">
          {!inStock && (
            <span className="bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
              Out of Stock
            </span>
          )}
        </div>

        <div className="flex flex-grow py-1">
          <div className="flex-grow flex flex-col gap-[2px] px-1">
            <p className="text-[#4D4D4D] font-semibold text-[12px] line-clamp-2">
              {capitalizeFirstLetter(name)}
            </p>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <p className="text-[Source Sans Pro] font-semibold text-[16px] text-black">
                  £ {price ? price : "N/A"}
                </p>
                &nbsp;
                {oldPrice && (
                  <p className="text-[Source Sans Pro] font-normal text-[13px] text-[#879088] line-through">
                    £ {oldPrice}
                  </p>
                )}
              </div>
            </div>
            {description && (
              <p className="font-normal text-[18px] max-h-12 overflow-hidden font-[Source Sans Pro] pr-2">
                {description}
              </p>
            )}
            {rating ? (
              <div className="flex gap-1 items-center">
                <p className="text-xs font-[Roboto] flex gap-1 font-normal text-[#171817]">
                  <Rating
                    allowFraction
                    initialValue={rating}
                    readonly
                    size={12}
                    fillColor="#FF8A00"
                    emptyColor="#E5E5E5"
                    SVGclassName="inline-block"
                  />
                </p>
              </div>
            ) : (
              <div className="flex items-center text-[8px]">
                No ratings yet!
              </div>
            )}
          </div>
          <div
            onClick={(e) => {
              e.stopPropagation();
              setIsModalOpen(true);
            }}
            className={`rounded-full bg-[#F2F2F2] cursor-pointer mr-2 border-[1px] p-1 self-center transition-all active:bg-[#05A30D] active:text-white hover:scale-125 hover:opacity-80 flex items-center justify-center h-[32px] w-[32px] ml-[2px] `}
          >
            <HiOutlineShoppingBag />
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        setISOpen={setIsModalOpen}
        title={`Add ${name} to cart`}
        content={
          <ProductDetailsModal
            isModalOpen={isModalOpen}
            image={image}
            home
            id={id}
            setIsModalOpen={setIsModalOpen}
          />
        }
      />
    </>
  );
};

export default Product;
